export enum PolicyTypeEnum {
  owner = 'owner',
  longForm = 'longForm',
  shortForm = 'shortForm',
}
